import { render } from "./ObjectCard.vue?vue&type=template&id=da73b7d4"
import script from "./ObjectCard.vue?vue&type=script&lang=js"
export * from "./ObjectCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__